<template>
  <div class="contacto-page">
    <main class="contacto-main">
      <header class="contacto-header">
        <h1 class="contacto-title">Contacto</h1>
        <p class="contacto-lead">Escribinos o llamanos cuando quieras. Estamos en Chivilcoy.</p>
      </header>

      <section class="contacto-info">
        <a href="mailto:finishtimechivilcoy@gmail.com" class="contacto-row contacto-row-link">
          <span class="contacto-row-icon"><v-icon color="orange" size="22">email</v-icon></span>
          <span class="contacto-row-label">Email</span>
          <span class="contacto-row-value">finishtimechivilcoy@gmail.com</span>
        </a>
        <a href="tel:5492346654774" class="contacto-row contacto-row-link">
          <span class="contacto-row-icon"><v-icon color="orange" size="22">phone</v-icon></span>
          <span class="contacto-row-label">Teléfono</span>
          <span class="contacto-row-value">2346 65-4774</span>
        </a>
        <div class="contacto-row">
          <span class="contacto-row-icon"><v-icon color="orange" size="22">place</v-icon></span>
          <span class="contacto-row-label">Ubicación</span>
          <span class="contacto-row-value">Chivilcoy, Buenos Aires, Argentina</span>
        </div>
      </section>

      <section class="contacto-redes">
        <p class="contacto-redes-text">Seguinos en redes</p>
        <div class="contacto-redes-list">
          <a href="https://www.facebook.com/people/Finish-Time-Chivilcoy/100057559483655/" target="_blank" rel="noopener noreferrer" class="redes-link redes-link-fb">
            <v-icon size="20">share</v-icon>
            <span>Facebook</span>
          </a>
          <a href="https://www.instagram.com/finishtimechivilcoy/" target="_blank" rel="noopener noreferrer" class="redes-link redes-link-ig">
            <v-icon size="20">photo_camera</v-icon>
            <span>Instagram</span>
          </a>
          <a href="https://wa.me/5492346654774" target="_blank" rel="noopener noreferrer" class="redes-link redes-link-wa">
            <v-icon size="20">chat</v-icon>
            <span>WhatsApp</span>
          </a>
        </div>
      </section>

      <div class="contacto-back">
        <router-link to="/" class="contacto-back-link">
          <v-icon small left>arrow_back</v-icon>
          Volver al inicio
        </router-link>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'Contacto',
};
</script>

<style scoped>
.contacto-page {
  min-height: 100vh;
  background: #fafafa;
  padding: 32px 20px 60px;
}

.contacto-main {
  max-width: 420px;
  margin: 0 auto;
}

.contacto-header {
  margin-bottom: 32px;
}

.contacto-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 8px 0;
  letter-spacing: -0.02em;
}

.contacto-lead {
  font-size: 1rem;
  color: #5c5c5c;
  margin: 0;
  line-height: 1.5;
}

.contacto-info {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ebebeb;
  overflow: hidden;
}

.contacto-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-bottom: 1px solid #f0f0f0;
}

.contacto-row:last-child {
  border-bottom: none;
}

.contacto-row-link {
  text-decoration: none;
  color: inherit;
  transition: background 0.15s;
}

.contacto-row-link:hover {
  background: #fafafa;
}

.contacto-row-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contacto-row-label {
  flex: 0 0 80px;
  font-size: 0.8125rem;
  color: #757575;
}

.contacto-row-value {
  flex: 1;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #1a1a1a;
  text-align: right;
}

.contacto-row-link .contacto-row-value {
  color: #ff9800;
}

.contacto-row-link:hover .contacto-row-value {
  color: #f57c00;
}

.contacto-redes {
  margin-top: 28px;
}

.contacto-redes-text {
  font-size: 0.875rem;
  color: #757575;
  margin: 0 0 12px 0;
}

.contacto-redes-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.redes-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 0.9375rem;
  font-weight: 500;
  text-decoration: none;
  color: #fff;
  transition: opacity 0.2s, transform 0.15s;
}

.redes-link:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}

.redes-link .v-icon {
  color: #fff !important;
}

.redes-link-fb {
  background: #1877f2;
}

.redes-link-ig {
  background: linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045);
}

.redes-link-wa {
  background: #25d366;
}

.contacto-back {
  margin-top: 36px;
}

.contacto-back-link {
  display: inline-flex;
  align-items: center;
  font-size: 0.9375rem;
  color: #757575;
  text-decoration: none;
}

.contacto-back-link:hover {
  color: #ff9800;
}

@media (min-width: 600px) {
  .contacto-page {
    padding: 48px 24px 80px;
  }

  .contacto-main {
    max-width: 480px;
  }

  .contacto-title {
    font-size: 2rem;
  }
}
</style>
